import { $document, $html, APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';
import mustache from 'mustache';

import { unescapeHtml } from '../utils/html';

const MODULE_NAME     = 'Calendar';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const Event = {
    CHANGE_MONTH: `clndr.next.${EVENT_NAMESPACE}`
};

/**
 * @typedef {Object} EventDateData
 *
 * @property {number}        year
 * @property {number|string} month - If the month is less than 10, the number is padded with `0`.
 * @property {number}        [day]
 * @property {string}        [category]
 */

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        /** @var {EventDateData} */
        this.currentData = {
            year:     options.year,
            month:    options.month,
            day:      options.day,
            category: options.category,
        };

        this.isLoading = false;
        this.template  = false;

        $document.on(Event.CHANGE_MONTH, () => this.goNext());
    }

    /**
     * Go to next month
     *
     * @return {this}
     */
    goNext() {
        this.$el.clndr().forward();
        this.changeMonth(this.$el.clndr().month);
        return this;
    }

    init() {
        this.momentTranslate();

        const template = unescapeHtml(this.$el.html());

        this.$el.clndr({
            events:                  [],
            template:                template,
            showAdjacentMonths:      true,
            adjacentDaysChangeMonth: true,
            classes: {
                past:          'is-past',
                today:         'is-today',
                event:         'has-events',
                selected:      'is-selected',
                inactive:      'is-inactive',
                lastMonth:     'is-last-month',
                nextMonth:     'is-next-month',
                adjacentMonth: 'is-adjacent-month',
            },
            clickEvents: {
                click: (target) => {
                    if (!$(target.element).hasClass('has-events')) {
                        return;
                    }

                    $('.c-calendar_day').removeClass('is-selected');
                    $(target.element).addClass('is-selected');

                    let month = (target.date.month() + 1);
                    if (month < 10) month = `0${month}`;

                    const data = {
                        day:   `${target.date.date()}`,
                        month: `${month}`,
                        year:  `${target.date.year()}`
                    };

                    if (this.currentCategory) {
                        data.category = `${this.currentCategory}`;
                    }

                    if (window.innerWidth <= 1000) {
                        $html.removeClass('has-breadcrumb-open');
                    }
                    this.changeDate(data);
                },
                onMonthChange: (moment) => {
                    this.changeMonth(moment);
                },
            },
            render: function (data) {
                return mustache.render(template, data);
            },
        });

        const data = this.updateCurrentData();

        if (data.year) {
            this.$el.clndr().setYear(data.year);
        }

        this.$el.clndr().setMonth(parseInt(data.month) - 1);

        this.fetchCalendarEvents(data);
    }

    /**
     * @return {EventDateData}
     */
    updateCurrentData() {
        if (this.currentData.month) {
            return this.currentData;
        }

        const today = new Date();

        let month = today.getMonth() + 1;
        if (month < 10) {
            month = `0${month}`;
        }

        const data = {
            month: `${month}`,
        };

        if (this.currentData.category) {
            data.category = this.currentData.category;
        }

        return data;
    }

    /**
     * @param {momem.Moment} moment
     */
    changeMonth(moment) {
        let month = (moment.month() + 1);
        if (month < 10) month = `0${month}`;

        const data = {
            month: `${month}`,
            year:  `${moment.year()}`
        };

        if (this.currentData.category) {
            data.category = `${this.currentData.category}`;
        }

        this.changeDate(data);

        return this;
    }

    /**
     * Fetch all calendar events
     *
     * @param {EventDateData} date
     */
    fetchCalendarEvents(date) {
        let urlParameters = Object.entries(date).map(e => e.join('=')).join('&');
        fetch('event-list?' + urlParameters).then(response => response.json()).then(json => {
            if (json.errors.length) {
                throw new Error(json.errors);
            }

            const {calendarDates} = json.success;
            this.$el.clndr().setEvents(calendarDates);

            $(window).trigger('resize');

            // this.isLoading = false;

            if (window.innerWidth > 1000) {
                $html.removeClass('has-breadcrumb-open');
            }

            $document.triggerHandler({
                type:    'scrollTo.LocomotiveScroll',
                options: {
                    speed: 600,
                    toTop: true,
                },
            })

        }).catch(errors => console.error(errors));
    }

    /**
     * Load events for given date
     *
     * @param {EventDateData} date
     */
    changeDate(date) {
        // if (this.isLoading) {
        //     return false;
        // }
        // this.isLoading = true;

        this.currentData = date;
        this.refresh();
    }

    /**
     * Navigate to URL
     *
     * @param {string} url
     */
    navigateTo(url) {
        $document.triggerHandler({
            type:       'goTo.Load',
            href:       url,
            transition: 'news',
        });
    }

    /**
     * Refresh page with given data
     */
    refresh() {
        let data = this.currentData;

        let url = 'calendrier/' + data.year + '/' + data.month;
        if (data.day) {
            url += '/' + data.day;
        }

        $('.js-breadcrumb-link').each((i,e) => {
            let linkUrl = url;

            let split = $(e).attr('href').split('cat=');
            if (split.length > 1) {
                linkUrl += '?cat='+split[split.length-1];
            }
            $(e).attr('href', linkUrl);
        });

        if (data.category) {
            url += '?cat=' + data.category;
        }

        this.fetchCalendarEvents(data);
        this.navigateTo(url);
    }

    momentTranslate() {
        moment.locale('fr-ca', {
            months:             'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
            monthsShort:        'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
            monthsParseExact:   true,
            weekdays:           'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
            weekdaysShort:      'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
            weekdaysMin:        'di_lu_ma_me_je_ve_sa'.split('_'),
            weekdaysParseExact: true,
            longDateFormat:     {
                LT:   'HH:mm',
                LTS:  'HH:mm:ss',
                L:    'YYYY-MM-DD',
                LL:   'D MMMM YYYY',
                LLL:  'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm',
            },
            calendar: {
                sameDay:  '[Aujourd’hui à] LT',
                nextDay:  '[Demain à] LT',
                nextWeek: 'dddd [à] LT',
                lastDay:  '[Hier à] LT',
                lastWeek: 'dddd [dernier à] LT',
                sameElse: 'L',
            },
            relativeTime: {
                future: 'dans %s',
                past:   'il y a %s',
                s:      'quelques secondes',
                ss:     '%d secondes',
                m:      'une minute',
                mm:     '%d minutes',
                h:      'une heure',
                hh:     '%d heures',
                d:      'un jour',
                dd:     '%d jours',
                M:      'un mois',
                MM:     '%d mois',
                y:      'un an',
                yy:     '%d ans',
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
            ordinal:                function (number, period) {
                switch (period) {
                    // Words with feminine grammatical gender: semaine
                    case 'w':
                    case 'W': {
                        return number + (number === 1 ? 're' : 'e');
                    }

                    // Words with masculine grammatical gender: mois, trimestre, jour
                    default:
                    case 'M':
                    case 'Q':
                    case 'D':
                    case 'DDD':
                    case 'd': {
                        return number + (number === 1 ? 'er' : 'e');
                    }
                }
            },
        });
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}

export {Event};
